<template>
    <nav class="grid">
        <ul class="inline-flex items-center justify-center p-0">
            <li class="group page-item flex items-center justify-center bg-white w-[15px] h-[15px] p-[20px] border border-gray-400 rounded-md me-2 shadow-sm"
                :class="{ 'disabled': currentPage === 1 }"
                @click.prevent="setCurrentPage(1)">
                <div>
                    <IconDoubleAngleRight class="w-6 h-6 rotate-180 transition md:group-hover:text-white"/>
                    <i class="fa-solid fa-angles-left"></i>
                </div>
            </li>
            <li class="group page-item flex items-center justify-center bg-white w-[15px] h-[15px] p-[20px] border border-gray-400 rounded-md me-2 shadow-sm"
                :class="{ 'disabled': currentPage === 1 }"
                @click.prevent="prevPage">
                <div>
                    <IconAngleLeft class="transition"/>
                </div>
            </li>
            <li v-if="visiblePages[0] > 1"
                class="group page-item flex items-center justify-center bg-white w-[15px] h-[15px] p-[20px] rounded-md more-pages no-hover me-2 cursor-default">
                <div class="text-black">...</div>
            </li>
            <li v-for="page in visiblePages" :key="page"
                class="group page-item flex items-center justify-center bg-white w-[15px] h-[15px] p-[20px] border border-gray-400 rounded-md me-2 shadow-sm page-number"
                @click.prevent="setCurrentPage(page)"
                :class="{ 'active': currentPage === page }">
                <div>{{ page }}</div>
            </li>
            <li class="pagination-text me-2 text-sm">
                Стр. {{ currentPage }} из {{ totalPages }}
            </li>
            <li v-if="visiblePages[visiblePages.length - 1] < totalPages"
                class="group page-item flex items-center justify-center bg-white w-[15px] h-[15px] p-[20px] rounded-md no-hover more-pages me-2 cursor-default">
                <div class="text-black">...</div>
            </li>
            <li class="group page-item flex items-center justify-center bg-white w-[15px] h-[15px] p-[20px] border border-gray-400 rounded-md me-2 shadow-sm"
                :class="{ 'disabled': currentPage === totalPages }"
                @click.prevent="nextPage">
                <div>
                    <IconAngleLeft class="rotate-180 transition"/>
                </div>
            </li>
            <li class="group page-item flex items-center justify-center bg-white w-[15px] h-[15px] p-[20px] border border-gray-400 rounded-md me-2 shadow-sm"
                :class="{ 'disabled': currentPage === totalPages }"
                @click.prevent="setCurrentPage(totalPages)">
                <div>
                    <IconDoubleAngleRight class="w-6 h-6 transition md:group-hover:text-white"/>
                </div>
            </li>
        </ul>
    </nav>
</template>

<script>
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";
import IconDoubleAngleRight from "@js/components/Icons/IconDoubleAngleRight.vue";

export default {
    components: {IconDoubleAngleRight, IconAngleLeft},
    props: {
        currentPage: {
            type: Number,
            required: true
        },
        totalPages: {
            type: Number,
            required: true
        },
        maxVisiblePages: {
            type: Number,
            default: 5 // Максимальное количество видимых страниц по умолчанию
        }
    },
    computed: {
        visiblePages() {
            const totalPages = this.totalPages;
            const currentPage = this.currentPage;
            const maxVisiblePages = this.maxVisiblePages;

            let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
            let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

            // Убедитесь, что мы показываем maxVisiblePages, если это возможно
            if (endPage - startPage + 1 < maxVisiblePages) {
                startPage = Math.max(1, endPage - maxVisiblePages + 1);
            }

            return Array.from({length: endPage - startPage + 1}, (_, i) => startPage + i);
        }
    },
    methods: {
        setCurrentPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.$emit('update:currentPage', page);
            }
        },
        prevPage() {
            this.setCurrentPage(this.currentPage - 1);
        },
        nextPage() {
            this.setCurrentPage(this.currentPage + 1);
        },
    }
};
</script>

<style lang="scss" scoped>
.page-item {
    transition: color, background-color .25s;
}

.page-item:not(.no-hover) {
    cursor: pointer;
}

.page-item:not(.no-hover):hover {
    background: var(--main-color);
    color: white;
}

.page-item.active {
    background: var(--main-color);
    color: white;
}

.pagination-text {
    display: none;
}

@media (max-width: 768px) {
    .page-number, .more-pages {
        display: none;
    }
    .pagination-text {
        display: flex;
        font-weight: 500;
    }
}
</style>
